<template>
  <div class="dm-empty">
    <a-icon :type="iconType" :style="{color: iconColor}" class="dm-empty-icon"/>
    <div class="dm-empty-main">{{ mainText }}</div>
    <div class="dm-empty-sub">{{ subText }}</div>
    <a-button v-if="action" type="primary" size="small" class="dm-empty-btn" @click="$emit('action')">{{ action }}</a-button>
  </div>
</template>

<script>
  export default {
    name: 'DmEmpty',
    props: {
      // empty=初始无数据 / filter=筛选无结果 / error=加载失败
      scene: {
        type: String,
        default: 'empty'
      },
      // 业务对象名，如：工单 / 司机 / 车辆
      bizName: {
        type: String,
        default: ''
      },
      // 引导按钮文案，为空则不显示按钮
      action: {
        type: String,
        default: ''
      }
    },
    computed: {
      iconType () {
        if (this.scene === 'filter') {
          return 'search'
        }
        if (this.scene === 'error') {
          return 'warning'
        }
        return 'inbox'
      },
      iconColor () {
        if (this.scene === 'error') {
          return '#FAAD14'
        }
        return '#d9d9d9'
      },
      mainText () {
        const biz = this.bizName || '数据'
        if (this.scene === 'filter') {
          return '没有找到匹配的' + biz
        }
        if (this.scene === 'error') {
          return '数据加载失败'
        }
        return '暂无' + biz
      },
      subText () {
        if (this.scene === 'filter') {
          return '试试调整筛选条件或清除筛选后再看'
        }
        if (this.scene === 'error') {
          return '网络异常或服务暂时不可用，请稍后重试'
        }
        // 有引导按钮时提示点按钮创建；无按钮时给通用文案（避免误导）
        if (this.action) {
          return '还没有' + (this.bizName || '数据') + '，点击下方按钮创建第一条'
        }
        return '暂无数据，可稍后刷新或调整筛选条件再试'
      }
    }
  }
</script>

<style lang="less" scoped>
  .dm-empty {
    text-align: center;
    padding: 48px 0;
  }
  .dm-empty-icon {
    font-size: 48px;
    margin-bottom: 12px;
  }
  .dm-empty-main {
    font-size: 15px;
    color: #333;
    font-weight: 600;
    margin-bottom: 6px;
  }
  .dm-empty-sub {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;
  }
  .dm-empty-btn {
    height: 28px;
    line-height: 26px;
    padding: 0 16px;
    border-radius: 14px;
  }
</style>
